import React from 'react';
import A from 'components/atoms/A/A';
import AppStoreLinks from 'components/atoms/AppStoreLinks/AppStoreLinks';
import Button from 'components/atoms/Button/Button';
import Heading from 'components/atoms/Heading/Heading';
import LocaleAwareImage from 'components/atoms/LocaleAwareImage/LocaleAwareImage';
import Txt from 'components/atoms/Txt/Txt';
import { CASHBACK, HOW_IT_WORKS, PUBLIC_EARN, SIGN_UP } from 'components/pages/pages';
import Trustpilot from 'components/molecules/Trustpilot/Trustpilot';
import FullWidthCta from 'components/organisms/FullWidthCta/FullWidthCta';
import SplitRow from 'components/organisms/SplitRow/SplitRow';
import SplitRowCta from 'components/organisms/SplitRow/SplitRowCta';

export interface Props {}

const LandingPageContentVanilla: React.FC<Props> = () => {
  return (
    <div>
      <Trustpilot
        title={
          <Heading level={2} uppercase>
            We&apos;re kind of a <span className="textHighlight">big deal...</span>
          </Heading>
        }
      />

      <SplitRow
        id="landingPageScrollToRow"
        leftColumn={
          <LocaleAwareImage
            src="/assets/homepage_image_1.png"
            alt="What is a paid survey site?"
            width={600}
            height={600}
          />
        }
        rightColumn={
          <>
            <Heading level={2} uppercase>
              <span className="textHighlight">Take part anytime,</span> anywhere
            </Heading>
            <Txt component="p">
              Take surveys on your commute, boost your income in your downtime, or fill your pockets
              while you study. Download our iOS or Android app, or use Qmee from your browser, and
              let Qmee work for you.
            </Txt>
            <AppStoreLinks hideRating />
          </>
        }
      />

      <SplitRow
        mobileColumnOrderSwapped
        rightColumn={
          <LocaleAwareImage
            src="/assets/homepage_image_2.png"
            alt="Cash out however you want, whenever you want"
            width={600}
            height={600}
          />
        }
        leftColumn={
          <>
            <Heading level={2} uppercase>
              <span className="textHighlight">Get rewards</span> however you want, whenever you want
            </Heading>
            <Txt component="p">
              Have your rewards any way you choose! With no minimum withdrawal amount, and a variety
              of ways to enjoy your rewards including PayPal, Venmo and gift cards, you can get them
              whenever you like, however you like.
            </Txt>
            <SplitRowCta>
              <Button
                component={A}
                color="primary"
                buttonType="primary"
                href={SIGN_UP.path}
                prefetch={false}
              >
                <Txt>Start Earning</Txt>
              </Button>
            </SplitRowCta>
          </>
        }
      />

      <SplitRow
        leftColumn={
          <LocaleAwareImage
            src="/assets/homepage_image_3.png"
            alt="Your opinion matters"
            width={600}
            height={600}
          />
        }
        rightColumn={
          <>
            <Heading level={2} uppercase>
              <span className="textHighlight">Your opinion</span> matters
            </Heading>
            <Txt component="p">
              There&apos;s a reason survey providers pay for completed surveys - your opinion
              matters to them! By answering surveys with Qmee you can get your voice heard and{' '}
              <Txt component="strong">influence your favorite brands</Txt>.
            </Txt>
            <SplitRowCta>
              <Button component={A} color="secondary" href={PUBLIC_EARN.path} prefetch={false}>
                <Txt>View Surveys</Txt>
              </Button>
            </SplitRowCta>
          </>
        }
      />

      <SplitRow
        mobileColumnOrderSwapped
        rightColumn={
          <LocaleAwareImage
            src="/assets/homepage_image_4.png"
            alt="Earn and save when you shop with Qmee"
            width={600}
            height={600}
          />
        }
        leftColumn={
          <>
            <Heading level={2} uppercase>
              <span className="textHighlight">Shop with Qmee</span> for rewards and savings
            </Heading>
            <Txt component="p">
              Qmee not only has surveys for you to take part in - our hand-picked offers let you
              enjoy real rewards when you make a purchase. You can also get yourself some savings
              when you use our exclusive discount codes!
            </Txt>
            <SplitRowCta>
              <Button
                component={A}
                color="secondary"
                buttonType="secondary"
                href={CASHBACK.path}
                prefetch={false}
              >
                <Txt>Show me cashback deals</Txt>
              </Button>
            </SplitRowCta>
          </>
        }
      />

      <FullWidthCta
        title={
          <>
            How do <span className="textHighlight">paid surveys</span> work?
          </>
        }
        ctaText="Tell me more"
        ctaLink={HOW_IT_WORKS.path}
      >
        Get provided with online market research surveys that best match your profile,
        <br />
        then get a cash reward whenever you complete a survey.
      </FullWidthCta>
    </div>
  );
};

export default LandingPageContentVanilla;
